import React, { useState } from "react";
import { DatePicker, Select, Input, Button } from "antd";
import moment from "moment";

const { RangePicker } = DatePicker;

const EmailDateFilters = ({ onFiltersChange }) => {
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedDateRange, setSelectedDateRange] = useState([]);
  const [dateOption, setDateOption] = useState(null);

  const handleApplyFilters = () => {
    const [from, to] = selectedDateRange || [];

    const filters = {
      user: selectedUser,
      fromDate: from ? moment(from).startOf("day").toISOString() : null,
      toDate: to ? moment(to).endOf("day").toISOString() : null,
    };

    onFiltersChange(filters);
  };

  const handleDateOptionChange = (value) => {
    setDateOption(value);

    let fromDate = null;
    let toDate = null;

    if (value === "currentMonth") {
      fromDate = moment().startOf("month");
      toDate = moment().endOf("month");
    } else if (value === "prevMonth") {
      fromDate = moment().subtract(1, "months").startOf("month");
      toDate = moment().subtract(1, "months").endOf("month");
    } else if (value === "nextMonth") {
      fromDate = moment().add(1, "months").startOf("month");
      toDate = moment().add(1, "months").endOf("month");
    }

    setSelectedDateRange([fromDate, toDate]);
  };

  return (
    <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
      <Input
        placeholder="Enter User Email"
        style={{ width: 200 }}
        value={selectedUser}
        onChange={(e) => setSelectedUser(e.target.value)}
      />

      <Select
        allowClear
        placeholder="Select Month"
        style={{ width: 200 }}
        value={dateOption}
        onChange={handleDateOptionChange}
      >
        <Select.Option value="currentMonth">Current Month</Select.Option>
        <Select.Option value="prevMonth">Previous Month</Select.Option>
        <Select.Option value="nextMonth">Next Month</Select.Option>
      </Select>

      <RangePicker
        style={{ width: 300 }}
        value={selectedDateRange}
        onChange={(range) => setSelectedDateRange(range)}
      />

      <Button type="primary" onClick={handleApplyFilters}>
        Apply
      </Button>
    </div>
  );
};

export default EmailDateFilters;
